    
<template>
    <a-spin :spinning="chartloading">
        <div class="dashBox">
            <div class="dashTitle">
                <span>api请求信息</span><span style="color:#333;font-size:12px;padding-left:20px;">  失败次数 {{sumFailure}}</span>
                <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange" style="width: 80px;float:right;margin-top:2px;" placeholder="请选择时间">
                    <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="name">
                        {{name}}
                    </a-select-option>
                </a-select>
            </div>
            <a-empty v-if="timeList.length == 0" description="暂无数据" style="margin-top:80px;" />

            <div id="apichartID" style="width: 100%;padding-top:10px;"></div>
        </div>
    </a-spin>
</template>

<script>
const perTimeValue = {
    '1秒':'1s',
    '1分钟':'1m',
    '5分钟':'5m',
    '10分钟':'10m',
    '1小时':'1h',
    '1天':'1d',
}
export default {
    data() {
        return {
            timeList:[],
            maxCount:1,
            failList:[],
            successList:[],
            successRateList:[],
            sumFailure:0,

            chartSys:null,
            perTimeValue,
            chartPerTime:'1分钟',
            sumChartValue:0,

            tempHostName:'',
            tempEnv:'',
            tempTimeRange:'',

            chartloading:false,

        }
    },

    methods: {
        handleChartPerTimeChange(v){
            let timeRanges = this.tempTimeRange.split('~');
            timeRanges[2] = v;

            this.loadData(this.tempEnv,this.tempHostName,timeRanges.join('~'),1);
        },
        getRealChartTime(timeType){
            // '1分钟':7,
            // '5分钟':8,
            // '15分钟':10,
            // '1小时':9
            let result = '1分钟';
            switch (timeType) {
                case '1天':
                    //每小时
                    result = '1小时'
                    break;
                case '1小时':
                    //每小时
                    result = '5分钟'
                    break;
                case '15分钟':
                    //每15分钟
                    result = '1分钟'
                    break;
                case '5分钟':
                    //5分钟
                    result = '1秒'
                    break;
                case '1分钟':
                    //1分钟
                    result = '1秒'
                    break;
                default:
                    break;
            }
            return result;
        },
        loadData(selectedEnv,hostName,timeRange,flag){
            let that = this;
            this.tempHostName = hostName;
            this.tempEnv = selectedEnv;
            this.tempTimeRange = timeRange;
            
            timeRange = timeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;
            if(flag != 1){
                that.chartPerTime = that.getRealChartTime(timeRange[2]);
            }
            let perN = that.perTimeValue[that.chartPerTime];
            let queryStr = "* | select count_if(res_statues = '200') as countsuccess,count_if(res_statues != '200') as countfailur,time_series(__time__, '"+perN+"', '%Y-%m-%d %H:%i:%s' ,'0') as occurtime from log  where project_name = '"+hostName+"' and log_type='api' group by occurtime order by occurtime";
            that.chartloading = true;
            let params = {
                projectname:'fp-zl-device',
                logstorename:selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){

                    let result = res.data.data;
                    let array = result.list;
                    that.timeList = [];
                    that.maxCount = 0;
                    that.failList = [];
                    that.successList = [];
                    that.successRateList = [];
                    that.sumFailure = 0;

                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        let tempTime = "";
                        if(this.chartPerTime == '1秒'){
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm:ss');
                        }
                        else{
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm');
                        }

                        that.timeList.push(tempTime);
                        let cF = parseInt(element.countfailur);
                        let cS = parseInt(element.countsuccess);
                        let cR = parseInt(((cS / (cS + cF)) * 100 ).toFixed(0))
                        that.failList.push(cF)
                        that.successList.push(cS)
                        that.successRateList.push(cR)
                        that.sumFailure += cF;
                        if(cS > that.maxCount){
                            that.maxCount = cS;
                        }
                        if(cF > that.maxCount){
                            that.maxCount = cF;
                        }
                    }

                    that.analystData();

                    
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("apichartID").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("apichartID"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
            
        },
        getDatailOption(){
            let that = this;
            let  colors = ['#5470C6', '#91CC75', '#EE6666'];

            let option = {
                color:colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                // toolbox: {
                //     feature: {
                //         dataView: {show: true, readOnly: false},
                //         magicType: {show: true, type: ['line', 'bar']},
                //         restore: {show: true},
                //         saveAsImage: {show: true}
                //     }
                // },
                legend: {
                    data: ['错误次数', '调用成功次数', '成功率']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: that.timeList,
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '数量',
                        min: 0,
                        max: that.maxCount,
                        interval: 50,
                        axisLabel: {
                            formatter: '{value} 次'
                        }
                    },
                    {
                        type: 'value',
                        name: '成功率',
                        min: 0,
                        max: 100,
                        interval: 10,
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: [
                    {
                        name: '错误次数',
                        type: 'bar',
                        data: that.failList
                    },
                    {
                        name: '调用成功次数',
                        type: 'bar',
                        data: that.successList
                    },
                    {
                        name: '成功率',
                        type: 'line',
                        yAxisIndex: 1,
                        data: that.successRateList
                    }
                ]
            };
            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

<style scoped>

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
